import { pointers } from '@wix/thunderbolt-becky-types'
import type { DataMapName } from '@wix/thunderbolt-becky-types'
import type { ConsumptionDataNode } from './dataNodes/utils/dataNodeUtils'
import type { ByRefsisCompNode } from '../../compNodeUtils'
import { Connections } from './dataNodes/Connections'
import { Behaviors } from './dataNodes/Behaviors'
import { Slots } from './dataNodes/Slot'
import { DocumentData } from './dataNodes/DocumentData'
import { Properties } from './dataNodes/Properties'
import { LayoutData } from './dataNodes/LayoutData'
import { ThemeData } from './dataNodes/ThemeData'
import { Variables } from './dataNodes/Variables'
import { structure } from './compNodes/structure'
import { isGhostComponent } from './compNodes/isGhostComponent'
import { RESOLVED_REF_IS_GHOST_COMPONENT_ASPECT, STRUCTURE_ASPECT } from '../../constants'

const {
	DATA_MAPS: { CONNECTIONS, BEHAVIORS, SLOTS, DATA, PROPERTIES, LAYOUT, STYLE, VARIABLES },
} = pointers.data

export const consumptionDataNodes: { [dataMapName in DataMapName]?: ConsumptionDataNode<any, any, any> } = {
	[CONNECTIONS]: Connections,
	[BEHAVIORS]: Behaviors,
	[SLOTS]: Slots,
	[DATA]: DocumentData,
	[PROPERTIES]: Properties,
	[LAYOUT]: LayoutData,
	[STYLE]: ThemeData,
	[VARIABLES]: Variables,
}

export const consumptionCompNodes: Record<string, ByRefsisCompNode<any, any>> = {
	[STRUCTURE_ASPECT]: structure,
	[RESOLVED_REF_IS_GHOST_COMPONENT_ASPECT]: isGhostComponent,
}
